import React from 'react'

import Image from '@/image.js'

const PressGrid = ({ content }) => {
  return (
    <div className='x pb15'>
      <div className='container--xl ma ac'>
        <h2 className='mb0 pb0'>{content.title}</h2>
        <div className='x f jcb aic fw p15 press__grid'>
          {content.pressItems.map((press, i) => (
            <div className='press__grid-single ac x' key={press._rev}>
              <a className='event__single-link h5 mt15 small caps medium f jcc aic' href={press.url} rel='noopener noreferrer' target='_blank'>
                <Image imageId={press.imageId} className='x' />
              </a>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default PressGrid